import '../../sass/blocks/finish-hero.scss';

import cachios from 'cachios';
import { updateSiteHeaderBasketNumber } from '../layouts/site-header';

(() => {
    const $finishHeros = document.querySelectorAll('.finish-hero');

    if (!$finishHeros) return;

    $finishHeros.forEach($finishHero => {
        // Add to cart els
        const $addToCartForm = $finishHero.querySelector('.finish-hero__add-to-cart-form');
        const $addToCartFormNonce = $addToCartForm?.querySelector('[name=armourcoat_theme_product_add_to_cart_wpnonce]');
        const $addToCartFormProductId = $addToCartForm?.querySelector('[name=product_id]');
        const $addToCartFormFinishId = $addToCartForm?.querySelector('[name=finish_id]');

        let addToCartSuccessStateInterval = null;
        let addToCartRemoveSuccessStateTimeout = null;

        const initModalAddToCartForm = () => {
            if (!$addToCartForm) return;

            const addToCart = ({
                nonce,
                productId,
                finishId,
            }) => {
                let loadingAnimating = true;

                setTimeout(() => {
                    loadingAnimating = false;
                }, 250);

                if (addToCartSuccessStateInterval) {
                    clearInterval(addToCartSuccessStateInterval);
                }

                if (addToCartRemoveSuccessStateTimeout) {
                    clearTimeout(addToCartRemoveSuccessStateTimeout);
                }
                
                $addToCartForm.classList.add('finish-hero__add-to-cart-form--loading');

                cachios.get(GLOBALS.AJAX_URL, {
                    params: {
                        action: 'armourcoat_theme_ajax_product_add_to_cart',
                        nonce: nonce,
                        product_id: productId,
                        finish_id: finishId,
                        cachbuster: Date.now(),
                    }
                }).then(response => {
                    if (!response?.data?.success) return;

                    addToCartSuccessStateInterval = setInterval(() => {
                        if (!loadingAnimating) {
                            $addToCartForm.classList.add('finish-hero__add-to-cart-form--success');

                            addToCartRemoveSuccessStateTimeout = setTimeout(() => {
                                $addToCartForm.classList.remove('finish-hero__add-to-cart-form--loading');
                                $addToCartForm.classList.remove('finish-hero__add-to-cart-form--success');
                            }, 2000);

                            clearInterval(addToCartSuccessStateInterval);
                        }
                    }, 100);

                    if (response?.data?.cartItemCount) {
                        updateSiteHeaderBasketNumber(response.data.cartItemCount);
                    }
                }).catch(thrown => {
                    console.log(thrown);
                    
                    $addToCartForm.classList.remove('finish-hero__add-to-cart-form--loading');
                }).finally(() => {
                });
            };

            if ($addToCartForm) {
                $addToCartForm.addEventListener('submit', e => {
                    e.preventDefault();

                    const productId = $addToCartFormProductId?.value;
                    const finishId = $addToCartFormFinishId?.value;

                    if (!productId || !finishId) return;

                    addToCart({
                        nonce: $addToCartFormNonce?.value,
                        productId,
                        finishId
                    });
                });
            }
        };

        initModalAddToCartForm();
    });
})();
